import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  size?: 'default' | 'small' | 'large';
  disabled?: boolean;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  'data-id'?: string;
}
export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'default',
  disabled = false,
  onClick,
  type = 'button',
  className = '',
  'data-id': dataId
}) => {
  const baseStyles = `
    inline-flex items-center justify-center font-semibold text-center
    transition-all duration-150 ease-in-out cursor-pointer
    border-2 rounded-md focus:outline-none focus:ring-3 focus:ring-sky-500/20
    disabled:opacity-50 disabled:cursor-not-allowed
    hover:transform hover:-translate-y-0.5
    active:transform active:translate-y-0
    font-sans
  `;
  const variantStyles = {
    primary: `
      bg-sky-600 text-white border-sky-600
      hover:bg-sky-700 hover:border-sky-700
      active:bg-sky-800 active:border-sky-800
      shadow-sm hover:shadow-md
    `,
    secondary: `
      bg-transparent text-sky-500 border-sky-500
      hover:bg-sky-50 hover:text-sky-600 hover:border-sky-600
      active:bg-sky-100
    `
  };
  const sizeStyles = {
    small: 'h-10 px-4 text-sm min-w-20',
    default: 'h-12 px-7 text-base min-w-32',
    large: 'h-14 px-8 text-lg min-w-36'
  };
  const combinedClassName = `
    ${baseStyles}
    ${variantStyles[variant]}
    ${sizeStyles[size]}
    ${className}
  `.replace(/\s+/g, ' ').trim();
  return <button type={type} onClick={onClick} disabled={disabled} className={combinedClassName} data-id="element-2801">
      {children}
    </button>;
};